import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import warningIcon from '../../../assets/svgs/warning.svg';

interface ActionConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  actionText: string;
}

const ActionConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  actionText,
}: ActionConfirmationModalProps) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      PaperProps={{
        style: styles.dialogPaper
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        style={styles.closeButton}
      >
        <CloseIcon />
      </IconButton>
      
      <DialogContent style={styles.dialogContent}>
        <div style={styles.warningIcon}>
          <img src={warningIcon} alt="Warning" style={styles.warningImage} />
        </div>
        
        <Box style={styles.contentContainer}>
          <Typography
            id="confirmation-dialog-title"
            style={styles.title}
          >
            {title}
          </Typography>
          
          <Typography style={styles.description}>
            {description}
          </Typography>
        </Box>
        
        <div style={styles.buttonContainer}>
          <Button
            onClick={onClose}
            style={styles.cancelButton}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            style={styles.actionButton}
            variant="contained"
          >
            {actionText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  dialogPaper: {
    borderRadius: 12,
    padding: 0,
    maxWidth: 400,
    width: '100%',
  },
  dialogContent: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column' as const,
  },
  closeButton: {
    position: 'absolute' as const,
    right: 24,
    top: 24,
    width: 24,
    height: 24,
    color: '#6b7280',
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    marginBottom: 32,
  },
  warningIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 32,
    flexShrink: 0,
  },
  warningImage: {
    width: 24,
    height: 24,
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 0,
    color: '#101828',
    fontFamily: 'Outfit',
  },
  description: {
    fontSize: 16,
    color: '#475467',
    fontWeight: 400,
    lineHeight: 1.5,
    fontFamily: 'Outfit',
  },
  buttonContainer: {
    display: 'flex',
    gap: 12,
    width: '100%',
    justifyContent: 'center',
  },
  cancelButton: {
    width: 170,
    height: 44,
    borderRadius: 8,
    padding: '10px 18px',
    textTransform: 'none' as const,
    fontSize: 16,
    fontWeight: 500,
    color: '#111827',
    backgroundColor: 'white',
    border: '1px solid #e5e7eb',
    fontFamily: 'Outfit',
    '&:hover': {
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
    },
  },
  actionButton: {
    width: 170,
    height: 44,
    borderRadius: 8,
    padding: '10px 18px',
    textTransform: 'none' as const,
    fontSize: 16,
    fontWeight: 500,
    color: 'white',
    backgroundColor: '#D92D20',
    fontFamily: 'Outfit',
    '&:hover': {
      backgroundColor: '#b91c1c',
    },
  },
};

export default ActionConfirmationModal;